// Types
import type { TApiHttpClientRequestConfig } from '~/misc/resource/types';

// Models
import { ManagerResource } from '~/modules/manager/resource/manager-resource.model';
import type { EFeatureName } from '~/misc/feature/types';
import type { TManagerFeature } from '~/modules/manager/types';

export class ManagerFeatureModel extends ManagerResource {
  index(
    companyId: number,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<TManagerFeature[]> {
    return this.get<TManagerFeature[]>(`companies/${companyId}/features`, undefined, requestConfig);
  }

  create(
    companyId: number,
    name: EFeatureName,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<TManagerFeature> {
    return this.post<TManagerFeature>(`companies/${companyId}/features`, { name }, requestConfig);
  }

  destroy(id: number, requestConfig?: TApiHttpClientRequestConfig): Promise<void> {
    return this.delete(`features/${id}`, undefined, requestConfig);
  }
}
